/**
 * @title postNIP
 * @param {*} data 
 * @returns Promise
 */
import { apiURL } from "../utils/constants"
import { message } from "antd"
import { Fonts } from "../utils/constants";

export function postNIP( consultaId : number, nip: string, quoteType:number ): any {
    const requestData = {
        consultaId: consultaId,
        nip: nip
    };
    if (quoteType === 0) {
        return new Promise((resolve, reject) => {
            fetch(apiURL + `/EkatenaBureau`,
                {
                    method: "POST",
                    body: JSON.stringify(requestData),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then(response => resolve(response.status))
                .catch(error => {
                    reject(error)
                    message.error({ content: 'Error al realizar la consulta, por favor intente de nuevo', style: { fontFamily: Fonts.sspRegular } });
                })
        }
        )
    }else if (quoteType === 1) {
        return new Promise((resolve, reject) => {        
            fetch(apiURL + `/CreditoBureau`,
                {
                    method: "POST",
                    body: JSON.stringify(requestData),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then(response => resolve(response.status))
                .catch(error => {
                    reject(error)
                    message.error({ content: 'Error al realizar la consulta, por favor intente de nuevo', style: { fontFamily: Fonts.sspRegular } });
                })
        })
    }
}

/**
 * @title PostRecuperaNIP
 * @param {*} data 
 * @returns Promise
 */

export function PostRecuperaNIP(data: any): any {
    return new Promise((resolve, reject) => {
        fetch(apiURL + `/ekatenaresendnip`,
            {
                method: "POST",
                body: data,
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then(response => resolve(response.status))
            .catch(error => {
                reject(error)
                message.error({ content: 'Error al realizar la consulta, por favor intente de nuevo', style: { fontFamily: Fonts.sspRegular } });
            })
    })
}

/**
 * @title getNIP
 * @param {number | undefined} PersonID 
 * @returns Promise
 */

export function getNIP(PersonID: number | undefined): any {
    return new Promise((resolve, reject) => {
        fetch(`https://cotizaws.abcleasing.com.mx:63748/api/NIP?physicPersonId=${PersonID}&appUrl=https://cotizador.abcleasing.com.mx:63748&sms=false&leaseChannel=true`)
            .then(response => response.json())
            .then(response => resolve(response))
            .catch(error => {
                reject(error)
                message.error({ content: 'Error al realizar la consulta, por favor intente de nuevo', style: { fontFamily: Fonts.sspRegular } });
            })
    })
}
